import React from 'react';
import { Inbox } from 'lucide-react';

export function EmptyState({ 
  icon: Icon = Inbox,
  title = 'No data yet',
  description = 'Data will appear here once available',
  showGraphic = true,
  className = ''
}) {
  return (
    <div className={`empty-state ${className}`}>
      {showGraphic && (
        <div className="empty-state-graphic">
          <svg width="60" height="40" viewBox="0 0 60 40" fill="none">
            <rect x="5" y="8" width="50" height="24" rx="4" stroke="currentColor" strokeWidth="1.5" strokeDasharray="4 2"/>
            <line x1="15" y1="16" x2="45" y2="16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <line x1="15" y1="24" x2="35" y2="24" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        </div>
      )}
      <div className="empty-state-icon">
        <Icon size={28} />
      </div>
      <h3 className="empty-state-title">{title}</h3>
      <p className="empty-state-description">{description}</p>
    </div>
  );
}

export default EmptyState;
